export const heading = ['S.No', 'Prefix', 'Start Number', 'Suffix', 'Taxability', 'Preview', 'Action'];
export const addNewSetting = {
  prefix: '',
  nextinvoicenumber: '',
  suffix: '',
  taxability: 1,
};
